import { useState } from 'react';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
// Components
import { ProductIcon } from 'pages/store/components';
import { TokenAmount } from '@/common/index';
import MetaMaskButton from '@/components/ExternalWallets/MetaMask/MetaMaskButton';
// Utils
import { handleCopyClick, toDollar, formatWalletAddress } from '@/utils/index';
// Styles & Assets
import { CopySolid } from '@/icons/iconComponents';
import angleDown from '@/icons/fontawesome/angle-down.svg';
import styles from './walletInfo.module.css';

const WalletInfo = ({
  brand,
  cartDisableCheckout,
  insufficientError,
  isDisabled,
  setAddFunds,
  handleSubmit,
  walletInfo,
}) => {
  const [walletShown, setWalletShown] = useState(true);
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = () => handleCopyClick(walletInfo.walletId, setIsCopied);

  const walletAddress = formatWalletAddress(walletInfo.walletId, 10, 10);
  const usdBalance = toDollar(walletInfo.usd || 0, 2);

  return (
    <div
      className={insufficientError ? styles.sectionWrapperError : styles.sectionWrapper}
    >
      <div className={styles.header}>
        <div className={styles.walletName}>
          <ProductIcon imageSource={brand.icon} marginRight={8} />
          <Typography variant="h4">{brand.brandName} Wallet</Typography>
        </div>
        <IconButton
          className={styles.dropIcon}
          onClick={() => setWalletShown(!walletShown)}
          data-core-qa="showWalletButton"
        >
          <img
            src={angleDown.src}
            className={walletShown ? styles.caretUp : styles.caretDown}
            alt="toggle wallet view"
          />
        </IconButton>
      </div>
      {walletShown && (
        <>
          <div className={styles.walletInfo}>
            <div className={styles.walletRow}>
              <div className={styles.addressWrapper}>
                <Typography className={styles.walletAddress}>{walletAddress}</Typography>
                <Tooltip title={isCopied ? 'Copied' : ''}>
                  <Button
                    variant="text"
                    color="grey"
                    sx={{ padding: 0 }}
                    onClick={handleClick}
                    data-core-qa="fundWalletButtonCopy"
                  >
                    <CopySolid className={styles.copyIcon} />
                  </Button>
                </Tooltip>
              </div>
              <div className={styles.walletAmounts}>
                <Typography variant="body1Dark" className={styles.usdAmount}>
                  {usdBalance}
                </Typography>
                <Typography
                  variant="body1Dark"
                  className={styles.ethAmount}
                  data-core-qa="fundWalletETH"
                >
                  <TokenAmount
                    amount={walletInfo.coinAmt}
                    token={walletInfo?.cryptoAsset?.display.symbol}
                    precision={walletInfo?.cryptoAsset?.display.decimalPrecision}
                  />
                </Typography>
              </div>
            </div>
          </div>
          {brand.brandName !== 'MetaMask' ? (
            <div className={styles.buttonContainer}>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size="medium"
                onClick={() =>
                  setAddFunds({ cryptoAsset: walletInfo.cryptoAsset, isOpen: true })
                }
                startIcon={<Add />}
              >{`Add more ${walletInfo?.cryptoAsset?.display.symbol}`}</Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={isDisabled || cartDisableCheckout}
                fullWidth
                data-core-qa="fundWalletButtonContinue"
              >
                Pay with {brand.brandName} Wallet
              </Button>
            </div>
          ) : (
            <div className={styles.buttonContainer}>
              <MetaMaskButton
                data-core-qa="fundWalletButtonMetamask"
                onClick={handleSubmit}
                disabled={isDisabled}
                color="secondary"
              >
                Pay with MetaMask
              </MetaMaskButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WalletInfo;
